module.exports = __webpack_public_path__ + "static/media/linen-care-banner.fe744ff1.jpg";